module.exports = __webpack_public_path__ + "img/plant-bedroom-pc.72d0cd8d.png";